import { Component, OnInit, Input, ChangeDetectionStrategy } from "@angular/core";
import { RecordData } from "src/app/types";
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { MatListModule } from "@angular/material/list";
import { th } from "date-fns/locale";
import { SHARED_IMPORTS } from "src/app/shared/standalone-imports";
import { GOST_I18N } from "./gost.i18n";

@Component({
  selector: "mwstftg-recording-card",
  templateUrl: "./mwstftg-recording.component.html",
  styleUrls: ["./recording.component.css"],
  providers: [MatListModule, FormsModule, ReactiveFormsModule],
  imports: SHARED_IMPORTS,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MwstFtGRecordingComponent implements OnInit {
  @Input() recordData: RecordData;

  mwstResults: ResultsSet[] = GOST_I18N.mwst.results.map(r => ({
    value: r.value,
    description: r.description,
  }));

  foodResults: ResultsSet[] = GOST_I18N.foodTest.results.map(r => ({
    value: r.value,
    description: r.description,
  }));

  results: ResultsSet[] = [];

  ngOnInit() {

    const recordType = this.recordData?.data.recordType;

    if (
      recordType === "MWST" ||
      recordType === "MWST_G" ||
      recordType === "MWST_G_DATA"
    ) {
      this.results = this.mwstResults;
    } else if (
      recordType === "FOOD_TEST" ||
      recordType === "FOOD_TEST_G" ||
      recordType === "FOOD_TEST_G_DATA"
    ) {
      this.results = this.foodResults;
    } else {
      console.error(
        "[ERROR] generic-recording.component.ts: unknown recordtype",
      );
    }
  }
}

interface ResultsSet {
  value: number;
  description: string;
}
